/** Kachel-Treppe (assets/logo.svg): 3×3, fünf Kacheln in Orange-Stufen. */
const FILL: Record<string, string> = { '0,2': '#F2B48F', '1,2': '#EE9F72', '1,1': '#EA8955', '2,1': '#E77438', '2,0': '#E35F1B' };

export function Logo({ size = 28 }: { size?: number }) {
  const tiles = [];
  for (let r = 0; r < 3; r++)
    for (let c = 0; c < 3; c++)
      tiles.push(<rect key={`${c},${r}`} x={c * 36} y={r * 36} width={28} height={28} rx={7} fill={FILL[`${c},${r}`] ?? 'var(--soft)'} />);
  return (
    <svg role="img" aria-label="dashy-dash" width={size} height={size} viewBox="0 0 100 100">
      {tiles}
    </svg>
  );
}
